(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .constant('strokeGainedShotType', createStrokeGainedShotType());

    function createStrokeGainedShotType() {
        return angular.createEnum({
            Tee: 1,
            Fairway: 2,
            Sand: 3,
            Green: 4,
            Other: [5, 'Rough/Other'],
            Penalty: 6,
            Recovery: 7
        });
    }
})();